// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取当前登录用户 - token 通过请求头传递 */
export async function currentUser(options?: { [key: string]: any }) {
  return request<API.ApiResponse<API.CurrentUser>>('/api/currentUser', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 退出登录接口 GET /api/logout.action -> 代理到 /logout.action */
export async function outLogin(options?: { [key: string]: any }) {
  return request<API.ApiResponse<void>>('/api/logout.action', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login.action -> 代理到 /login.action */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  // 后端使用 @RequestParam，需要 form-urlencoded 格式
  const formData = new URLSearchParams();
  if (body.clientAccount) formData.append('clientAccount', body.clientAccount);
  if (body.username) formData.append('username', body.username);
  if (body.password) formData.append('password', body.password);

  return request<API.ApiResponse<string>>('/api/login.action', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: formData.toString(),
    ...(options || {}),
  });
}

/** 获取微信二维码 */
export async function getWechatQrcode(
  body: { partnerKey: string; account: string; affCode?: string },
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<{ qrcode: string; ticket: string }>>(
    '/api/getWechatQrcode',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 注册接口 */
export async function register(
  params: { ticket: string; openid: string; unionid: string },
  options?: { [key: string]: any },
) {
  const formData = new URLSearchParams();
  formData.append('ticket', params.ticket);
  formData.append('openid', params.openid);
  formData.append('unionid', params.unionid);

  return request<API.ApiResponse<void>>('/api/register', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: formData.toString(),
    ...(options || {}),
  });
}

/** 获取微信扫码登录二维码 */
export async function getWechatQrcode4Login(options?: { [key: string]: any }) {
  return request<API.ApiResponse<{ qrcode: string; ticket: string }>>(
    '/api/getWechatQrcode4Login',
    {
      method: 'POST',
      ...(options || {}),
    },
  );
}

/** 微信扫码登录 */
export async function login4Scan(
  params: { openid: string; unionid: string },
  options?: { [key: string]: any },
) {
  const formData = new URLSearchParams();
  formData.append('openid', params.openid);
  formData.append('unionid', params.unionid);

  return request<API.ApiResponse<string>>('/api/login4Scan.action', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: formData.toString(),
    ...(options || {}),
  });
}

/** 获取邀请链接 */
export async function getAffCode(options?: { [key: string]: any }) {
  return request<API.ApiResponse<string>>('/api/getAffCode', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取平台消息/公告 */
export async function getPlatformNews(options?: { [key: string]: any }) {
  return request<API.ApiResponse<{ title: string; url: string; orderId: number }>>('/api/getPlatformNews', {
    method: 'GET',
    ...(options || {}),
  });
}

/** Google 登录接口 */
export async function googleLogin(
  body: { idToken: string; affCode?: string },
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<string>>('/api/googleLogin', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
